<template lang="pug">
.modal-view-contract
    el-dialog(
        :visible.sync='mostrar',
        width='60%',
        :before-close='fechar'
        :destroy-on-close='true',
        close='fechar'
    )
        .view-contract
            py(v-if="mostrar" :contractId="contractId")
        .close-button
            BaseButton(@click='fechar', size='mini')
                | {{ $t('mensagens.comuns.voltar') }}
</template>
<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import py from '@/modules/traceability-contract/views/pages/view/py.vue';

export default {
    name: 'ModalViewContract',
    components: { py, BaseButton},
    emits: ['fechar'],
    props: {
        mostrar: {
            type: Boolean,
            default: false
        },
        contractId: {
            type: Number,
            default: null
        }
    },
    methods: {
        fechar() {
            this.$emit('fechar');
        }
    }
};
</script>
<style lang="scss">
.modal-view-contract {
    .view-contract {
        margin: 20px 0 20px 0;
    }
    .close-button {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
